import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=0235aa50&scoped=true&"
import script from "./ThankYouPage.vue?vue&type=script&async=true&lang=js&"
export * from "./ThankYouPage.vue?vue&type=script&async=true&lang=js&"
import style0 from "./ThankYouPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ThankYouPage.vue?vue&type=style&index=1&id=0235aa50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0235aa50",
  null
  
)

export default component.exports